import { useLocationProperty } from 'wouter/use-location';

import { getIsWaitingForAuth } from './useAuth';

export const useIsWaitingForAuth = () => useLocationProperty(() => getIsWaitingForAuth(location.search));
